export class PageTitle {

    public static getSponsorTitle(title?: string): string {
        return PageTitle.getTitle('Sponsor Portal', title);
    }

    public static getAdminTitle(title?: string) {
        return PageTitle.getTitle('Investigator Portal', title);
    }

    public static getInvestigatorTitle(title?: string) {
        return PageTitle.getTitle('Investigator Portal', title);
    }

    private static getTitle(mainTitle: string, subTitle: string): string {
        if (! subTitle) {
            return mainTitle;
        }

        return `${mainTitle} - ${subTitle}`;
    }
}